/**
 * Rendered key cap — the visual unit for every keyboard shortcut in the
 * app, used in both inline menu hints (e.g. inbox row menu) and the
 * Shift+? cheatsheet. Keep the styling in one place so the two surfaces
 * never drift.
 */
export function Kbd({ children }: { children: React.ReactNode }) {
  return (
    <kbd className="inline-flex min-w-[1.5rem] items-center justify-center rounded border border-border bg-muted px-1.5 py-0.5 font-mono text-xs font-medium text-foreground">
      {children}
    </kbd>
  );
}
